import {useAppStore} from '../appStore'

export const homeActions = {
  useSetBreadcrumb: () => useAppStore(s => s.setBreadcrumb),
} as const
